import ModalPanel from '@admin/components/modal_panel'
import Scrollbar from '@admin/components/scrollbar'
import Range from '@admin/components/form/range'
import PropTypes from 'prop-types'
import React from 'react'

class Timestamp extends React.Component {

  static propTypes = {
    timestamp: PropTypes.number,
    video: PropTypes.object,
    onBack: PropTypes.func,
    onDone: PropTypes.func
  }

  state = {
    timestamp: 0,
    duration: 0
  }

  videoRef = React.createRef()

  _handleBack = this._handleBack.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleMetadata = this._handleMetadata.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Scrollbar className="maha-social-designer-keyframefield-picker">
          <div className="maha-social-designer-keyframefield-picker-video">
            <video { ...this._getVideo() } />
            <Range { ...this._getRange() } />
          </div>        
        </Scrollbar>
      </ModalPanel>
    )
  }

  componentDidMount() {
    const { timestamp } = this.props
    if(timestamp) this._handleUpdate(timestamp)
  }

  _getPanel() {
    return {
      title: 't(Choose Cover Image)',
      leftItems: [
        { svg: 'chevron_left', handler: this._handleBack }
      ],
      rightItems: [
        { label: 't(Proceed)', handler: this._handleDone }
      ]
    }
  }

  _getRange() {
    const { duration, timestamp } = this.state
    return {
      debounce: null,
      min: 0,
      max: duration,
      step: 0.01,
      value: timestamp,
      onChange: this._handleUpdate
    }
  }

  _getVideo() {
    return {
      ref: this.videoRef,
      src: this.props.video.asset.signed_url,
      autoPlay: false,
      controls: false,
      muted: true,
      onLoadedMetadata: this._handleMetadata
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleDone() {
    const { timestamp } = this.state
    this.props.onDone(Number(timestamp.toFixed(2)))
  }

  _handleMetadata() {
    this.setState({ 
      duration: this.videoRef.current.duration
    })
  }

  _handleUpdate(timestamp) {
    this.videoRef.current.currentTime = timestamp
    this.setState({ timestamp })
  }
}

export default Timestamp